// `cursor: not-allowed` is a legacy literal copied from `InlineInput`'s own `canEdit === false`
// rendering (libs/webui/input/src/InlineInput/index.tsx) — flagged here, not re-copied as a new
// inline style; no Bootstrap utility class covers this cursor value.
.disabledAddress {
  cursor: not-allowed;
}

// The anchored card's fixed width — static values, not computed ones, belong in the module
// (`webui-styling-style-guide.md` §2); the `calc()` clamp only keeps it inside a narrow viewport,
// it does not depend on anything Bootstrap could express instead.
.card {
  width: 480px;
  max-width: calc(100vw - 1rem);
}
